/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState, useMemo} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import csvDownload from 'json-to-csv-export'

import {
    makeStyles, 
    Theme, 
    Container, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle,
    Grid, 
    Button} from '@material-ui/core';

import { AppContext } from '../stores/AppStore';
// import { UserContext } from '../stores/UserStore';
import { SecurityContext } from '../stores/SecurityStore';

import DataTable from '../components/table/DataTable';


import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AppsIcon from '@material-ui/icons/Apps';
import ReorderIcon from '@material-ui/icons/Reorder';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(2,2,0,2),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        alignItems: 'stretch',
        height: '92vh'
    },
    header: {
        backgroundColor: 'transparent',
        flex: '50px 0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '10px'
    },
    toolbar: {
        // margin: 2
    },    
    backButton: {
        backgroundColor: '#FFFFFF',
        minWidth: '40px',
        marginRight: '10px'      
    },
    gradientButton: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.primary,
        height: 32,
        borderRadius: '4px',
        background: 'linear-gradient(136.14deg, #009EE0 0%, #172983 100%)',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.14)',
        textTransform: 'none' 
    },
    viewButton: {
        height: 26,
        width: 70,
        fontSize: 12,
        fontWeight: 500,
        backgroundColor: '#F8F9FA',
        color: theme.palette.primary.main,
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.14)',
        textTransform: 'none' 
    },    
    title: {
        fontSize: 24,
        fontWeight: 700,
        marginRight: 16,
    },
    dialogTitle: {
        padding: '10px 24px 0px 24px',
    },
    dialogContent: {
        '& .MuiDialogContentText-root': {
            fontSize: 16,
            color: '#ffffffc4',
            lineHeight: 1
        }
    },

}));

// const userTypes = [
//     {value: 'employee', text: 'Vallourec Employee'},
//     {value: 'customer', text: 'Customer'},
//     {value: 'third', text: 'Third'},
//     {value: 'other', text: 'Other'},
// ];


const ManageUsers = () => {
    const history = useHistory();
    const classes = useStyles();
    const { appId }: any = useParams();    
    const { applicationSearchText, setApplicationSearchText, showErrorMessage } = useContext(AppContext);
    // const { currentUser } = useContext(UserContext);

    const { manageUsersData, getManageUsersData, changeUserAppStatus, removeUserData } = useContext(SecurityContext);

    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [removeUser, setRemoveUser] = useState(null);

    useEffect(() =>  {
        if (applicationSearchText) {
            setApplicationSearchText('');
            history.push('/search/users/'+applicationSearchText);
        }
    }, [applicationSearchText]);

    useEffect(() =>  {
        init();
    }, [appId]);

    useEffect(() =>  {
        setData(JSON.parse(JSON.stringify(manageUsersData.users)));
    }, [manageUsersData]);

    const init = () => {
        if (appId) {
            setLoading(true);
            getManageUsersData(appId).catch(errorMessage => {
                showErrorMessage(errorMessage);
            }).finally(() => {
                setLoading(false);            
            });    
        } else {
            history.replace('/home');
        }
    };

    const handleBack = () => {
        history.goBack()
    };

    // const handleNewUser = () => {
    //     history.push('/manage/user/');
    // };

    const handleEditUser = (event, rowData) => {
        history.push('/manage/user/'+appId+'/'+rowData.id);
    };

    const handleDeleteUser = (event, rowData) => {
        setRemoveUser(rowData);
    };
    
    const onDeleteUserClick = async (event) => {
        setLoading(true);
        try {
            setRemoveUser(null);
            await removeUserData(removeUser.id);
            await getManageUsersData(appId);
        } catch (errorMessage) {
            showErrorMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleToggleChange = (event, rowData) => {
        const inactive = rowData.inactive === undefined ? true : !rowData.inactive;
        
        const newData = [...data];
        const obj = newData.find(x => x.id === rowData.id);
        obj.inactive = inactive;
        setData(JSON.parse(JSON.stringify(newData)));
        
        changeUserAppStatus(rowData.id, appId, inactive).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setLoading(false);            
        });    
    };

    const renderRemoveDialog = useMemo(() => <Dialog
        disableBackdropClick
        disableEscapeKeyDown            
        fullWidth
        maxWidth="sm"
        open={removeUser !== null}
        aria-labelledby="delete-dialog">
        <DialogTitle className={classes.dialogTitle} id="delete-dialog" >Delete User</DialogTitle>
        <DialogContent className={classes.dialogContent} dividers={false}>
            <DialogContentText>
                Do you want DELETE the user "{removeUser && removeUser.firstName + ' ' + removeUser.lastName}" permanently? 
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={()=> { setRemoveUser(null) }}>
                Close
            </Button>
            <Button variant="contained" color="primary" startIcon={<DeleteIcon />} onClick={onDeleteUserClick} >
                Delete
            </Button>
        </DialogActions>
    </Dialog>, [removeUser, isLoading]); 

    const renderDataTable = useMemo(() => <DataTable
        isLoading={isLoading}
        // selection={true}
        // tableLayout="auto"
        columns={[
            { title: 'First Name', field: 'firstName' },
            { title: 'Last Name', field: 'lastName', cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
            { title: 'Email', field: 'email' },
            { title: 'Request Access', field: 'requestDate', render: rowData => <span>{new Date(rowData.requestDate).toLocaleDateString()}</span> },
            { title: 'Company', field: 'company', cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
            // { title: 'User Type', field: 'type', render: rowData => <span>{rowData.type && userTypes.find(x => x.value === rowData.type).text}</span> },
            { title: 'Phone Number', field: 'phoneNumber', render: rowData => <span>{(rowData.countryCode ? rowData.countryCode + ' ' : '') + rowData.phoneNumber ? rowData.phoneNumber : '' }</span> }
        ]}
        data={data}
        exportCsv={(columns, data) => {
            const csvData = [];
            for (const d of data) {
                const obj = {};
                for (const c of columns) {
                    obj[c.title] = d[c.field];
                }
                // obj['Profiles'] = d.profileName;
                csvData.push(obj);
            }
            csvDownload(csvData, 'users_'+Date.now()+'.csv', ';');
        }}        

        actions={[
            {
                icon: () => <EditIcon color="primary" />,
                tooltip: 'Edit User',
                position: 'row',
                disabledData: 'disabled',
                onClick: handleEditUser
            },
            {
                icon: () => <DeleteIcon color="error" />,
                tooltip: 'Delete User',
                position: 'row',
                disabledData: 'disabled',
                onClick: handleDeleteUser,
            },
            {
                tooltip: 'Activate / Inactivate',
                position: 'row',
                disabledData: 'disabled',
                toggleData: 'inactive',
                onClick: handleToggleChange,
            },
            {
                icon: () => <AppsIcon color="primary" />,
                tooltip: 'To be defined',
                onClick: (event) => init(),
                isFreeAction: true
            },
            {
                icon: () => <ReorderIcon color="primary" />,
                tooltip: 'To be defined',
                onClick: (event) => init(),
                isFreeAction: true
            }
        ]}   
        />, [data, isLoading]); 


    return (
        <Container className={classes.root} maxWidth="xl">
            <Grid container spacing={0} className={classes.header}>
                <span className={classes.title}>
                    <Button className={classes.backButton} color="primary" component="span" onClick={handleBack}>
                        <ArrowBackOutlinedIcon/>
                    </Button> 
                    
                    {manageUsersData?.application?.label}
                </span>
                <div className={classes.toolbar}>
                    {/* { currentUser && currentUser.isSuperAdmin && <Button variant="contained" className={classes.gradientButton} style={{width: 150}} onClick={handleNewUser} >
                        Add User
                    </Button> } */}
                </div>
            </Grid>
            { renderDataTable } 
            { renderRemoveDialog }

        </Container>
    );
};

export default ManageUsers;
